<template>
  <div>
    <div class="container" style="padding:15px; margin-top:10px; margin-bottom:10px">
      <div>
        <h4 class="grey-text text-darken-3">Our Church</h4>
        <div class="row">
            <div class="col s4">
              <img class="materialboxed" style="position:relative; width:100%; height:auto" src="./../assets/img/church.jpg">
            </div>
            <div class="col s4">
              <img class="materialboxed" style="position:relative; width:100%; height:auto" src="./../assets/img/ss.jpg">
            </div>
            <div class="col s4">
              <img class="materialboxed" style="position:relative; width:100%; height:auto" src="./../assets/img/ss.jpg">
            </div>
        </div>
      </div>
      <div>
        <h4 class="grey-text text-darken-3">Sunday School</h4>
        <div class="row">
            <div class="col s4">
              <img class="materialboxed" style="position:relative; width:100%; height:auto" src="./../assets/img/ss.jpg">
            </div>
            <div class="col s4">
              <img class="materialboxed" style="position:relative; width:100%; height:auto" src="./../assets/img/ss.jpg">
            </div>
            <div class="col s4">
              <img class="materialboxed" style="position:relative; width:100%; height:auto" src="./../assets/img/ss.jpg">
            </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
function init(){
  var elems = document.querySelectorAll('.materialboxed');
  var instances = M.Materialbox.init(elems, {});
}
export default {
  name: "Gallery",
  mounted: init
}
</script>



// WEBPACK FOOTER //
// src/components/Gallery.vue